/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerFindAllQueryResponse, TemplateQuestionPromptsControllerFindAllQueryParams, TemplateQuestionPromptsControllerFindAll401, TemplateQuestionPromptsControllerFindAll403 } from "../../models/checklistsController/TemplateQuestionPromptsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateQuestionPromptsControllerFindAll } from "../../clients/checklistsService/templateQuestionPromptsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateQuestionPromptsControllerFindAllQueryKey = (params: TemplateQuestionPromptsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-template-question-prompts'
}, ...(params ? [params] : [])] as const;
export type TemplateQuestionPromptsControllerFindAllQueryKey = ReturnType<typeof templateQuestionPromptsControllerFindAllQueryKey>;
export function templateQuestionPromptsControllerFindAllQueryOptions(params?: TemplateQuestionPromptsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateQuestionPromptsControllerFindAllQueryKey(params);
  return queryOptions<TemplateQuestionPromptsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerFindAll401 | TemplateQuestionPromptsControllerFindAll403>, TemplateQuestionPromptsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateQuestionPromptsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all checklist template question prompts
 * {@link /api/v1/checklist-template-question-prompts}
 */
export function useTemplateQuestionPromptsControllerFindAll<TData = TemplateQuestionPromptsControllerFindAllQueryResponse, TQueryData = TemplateQuestionPromptsControllerFindAllQueryResponse, TQueryKey extends QueryKey = TemplateQuestionPromptsControllerFindAllQueryKey>(params?: TemplateQuestionPromptsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateQuestionPromptsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerFindAll401 | TemplateQuestionPromptsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateQuestionPromptsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...templateQuestionPromptsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateQuestionPromptsControllerFindAll401 | TemplateQuestionPromptsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}